<template>
  <div class="detail">
    <div v-for="cell in cells" :key="cell.label" class="content">
      <div>{{ cell.label }}</div>
      <div>{{ cell.value | valueFormatter }}</div>
    </div>
  </div>
</template>
<style scoped>
.detail {
  display: flex;
  font-size: 14px;
  flex-direction: column;
}

.content {
  display: flex;
  flex-direction: row;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding: 4px 20px;
  color: #333333;
  font-size: 14px;
  font-weight: bold;
}
</style>

<script>
const findLabel = function (header, index, headerIndex) {
  let label = header[index]
  if (!label) {
    // 未命中
    if (headerIndex === 0) {
      const keys = Object.keys(header)
      if (index > keys[0] && index < keys[keys.length - 1]) {
        while (index >= 0) {
          label = header[--index]
          if (label || index < 0) {
            break
          }
        }
      }
    }
  }
  return label || ''
}

export default {
  name: 'ExcelRow',
  components: {},
  filters: {
    valueFormatter: function (value) {
      if (value && value.indexOf('.') !== -1) {
        const numberValue = Number(value)
        if (!isNaN(numberValue)) {
          return numberValue.toFixed(2)
        }
      }
      return value || '--'
    }
  },
  props: {
    data: {
      type: Object,
      default: () => undefined
    }
  },
  computed: {
    cells() {
      if (!this.data) {
        return []
      }
      const headers = JSON.parse(this.data.headers)
      const row = JSON.parse(this.data.row)
      let maxCellIndex = 0
      headers.forEach(function (header) {
        const keys = Object.keys(header)
        maxCellIndex = Math.max(keys[keys.length - 1], maxCellIndex)
      })
      const cells = []
      while (maxCellIndex >= 0) {
        let label = ''
        headers.forEach(function (header, index) {
          label = label + findLabel(header, maxCellIndex, index)
        })
        const value = row[maxCellIndex] || ''
        cells.unshift({
          label,
          value
        })
        maxCellIndex--
      }
      return cells
    }
  },
  watch: {},
  created() {
  },
  methods: {}
}
</script>
